<template>
  <div>
    <label v-if="label" class="pl-2 label-text">
      {{ label }}
      <v-icon v-if="required" class="uikit-icon mini-star size-mini-star error" />
    </label>

    <div v-if="hint" class="pl-2">
      {{ hint }}
    </div>

    <v-rating
      v-model="dataValue"
      :readonly="disabled"
      :background-color="backgroundColor"
      :dense="dense"
      :half-increments="halfIncrements"
      :hover="hover"
      @input="changeData"
    />
  </div>
</template>

<script>
export default {
  name: 'UIRating',

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [Number, null],
      default: null,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'primary',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    halfIncrements: {
      type: Boolean,
      default: true,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: String,
      default: '',
    },
  },

  data: () => ({ dataValue: null }),

  methods: {
    changeData(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      },
    },
  },
}
</script>
